(function() {
  'use strict';

  const ESTADOS_PRIVILEGIADOS = ['SP', 'MG', 'RJ', 'ES'];
  const API_URL = 'https://get.geojs.io/v1/ip/geo.json';
  const TIMEOUT_MS = 2000;
  const CACHE_KEY = 'sevet_user_state';

  const ESTADOS_MAP = {
    'São Paulo': 'SP',
    'Sao Paulo': 'SP',
    'Minas Gerais': 'MG',
    'Rio de Janeiro': 'RJ',
    'Espírito Santo': 'ES',
    'Espirito Santo': 'ES'
  };

  function fetchComTimeout(url, ms) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), ms);
    return fetch(url, { signal: controller.signal })
      .finally(() => clearTimeout(timeoutId));
  }

  async function detectarEstado() {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached !== null) {
        return cached === 'null' ? null : cached;
      }

      const response = await fetchComTimeout(API_URL, TIMEOUT_MS);
      if (!response.ok) {
        sessionStorage.setItem(CACHE_KEY, 'null');
        return null;
      }

      const data = await response.json();

      if (data.country_code !== 'BR') {
        sessionStorage.setItem(CACHE_KEY, 'null');
        return null;
      }

      const estado = ESTADOS_MAP[data.region] || null;
      sessionStorage.setItem(CACHE_KEY, estado || 'null');
      return estado;
    } catch (e) {
      return null;
    }
  }

  function aplicarPersonalizacao(estado) {
    if (!estado || !ESTADOS_PRIVILEGIADOS.includes(estado)) return;

    const subtitulos = document.querySelectorAll('[data-frete-subtitulo]');
    subtitulos.forEach(el => {
      el.innerHTML = '<p>Frete grátis acima de R$200 no seu estado</p>';
    });
  }

  async function init() {
    const estado = await detectarEstado();
    aplicarPersonalizacao(estado);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

